import Bugsnag from '@bugsnag/js'
import {get_message} from './messages'
import {notify} from './notifications'

export const noop = () => {}

export const ready = async fn => {
  if (document.readyState !== 'loading') {
    await fn()
  } else {
    document.addEventListener('DOMContentLoaded', async () => await fn())
  }
}

export const dqs = (selector) => {
  const nodes = document.querySelectorAll(selector)

  if(nodes.length === 0) {
    return null
  }

  if(nodes.length === 1) {
    return nodes[0]
  }

  return Array.from(nodes)
}

export const get_bugsnag = () => {
  if(Bugsnag._client === null) {
    Bugsnag.start({apiKey: process.env.BUGSNAG_API_KEY})
  }

  return Bugsnag
}

export const error_handler = error => {
  const bugsnag = get_bugsnag()

  console.error(error)
  bugsnag.notify(error)

  notify(get_message('ERROR'), 'danger', () => window.location.reload())

  sessionStorage.removeItem('access_token')
  sessionStorage.removeItem('user')

  return false
}
